// Shared design tokens for the redesigned Purchase pages. Page-specific tokens stay in each page's own styles file.
export const COLOR = {
  navy: "#0f1f3d",
  navyLight: "#1a2f52",
  grayBg: "#f4f6fb",
  grayBorder: "#e2e8f0",
  textPrimary: "#0f1f3d",
  textSecondary: "#64748b",
  textMuted: "#94a3b8",
  success: "#16a34a",
  danger: "#dc2626",
  warning: "#d97706",
  link: "#1d4ed8",
  iconIndigo: { bg: "#eef2ff", fg: "#4338ca" },
  iconAmber: { bg: "#fef3c7", fg: "#b45309" },
  iconRed: { bg: "#fee2e2", fg: "#dc2626" },
  iconGreen: { bg: "#dcfce7", fg: "#16a34a" },
  iconSlate: { bg: "#f1f5f9", fg: "#475569" },
};

export const pill = (tone) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 5,
  fontSize: 12,
  fontWeight: 600,
  padding: "3px 10px",
  borderRadius: 999,
  background: tone.bg,
  color: tone.text,
  border: `1px solid ${tone.border}`,
  whiteSpace: "nowrap",
});

export const btnBase = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 6,
  borderRadius: 8,
  padding: "9px 16px",
  fontSize: 13,
  fontWeight: 600,
  cursor: "pointer",
  border: "none",
};

export const btnPrimary = {
  ...btnBase,
  background: COLOR.navy,
  color: "#fff",
};

export const btnOutline = {
  ...btnBase,
  background: "#fff",
  color: COLOR.textPrimary,
  border: `1px solid ${COLOR.grayBorder}`,
};

// Pairs with style={btnOutline} — index.scss's global button border rule beats the inline one otherwise.
export const btnOutlineClassName = "btnOutlineBorder";

export const btnDanger = {
  ...btnBase,
  background: COLOR.danger,
  color: "#fff",
};

export const th = {
  fontSize: 11,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  color: COLOR.textSecondary,
  fontWeight: 600,
  background: COLOR.grayBg,
  whiteSpace: "nowrap",
  padding: "10px 16px",
  borderBottom: `1px solid ${COLOR.grayBorder}`,
  textAlign: "left",
};

export const td = {
  fontSize: 13,
  color: COLOR.textPrimary,
  verticalAlign: "middle",
  padding: "12px 16px",
  borderBottom: `1px solid ${COLOR.grayBorder}`,
};

// Pins react-select to Bootstrap's 38px .form-control height and portals its menu to <body>.
const SELECT_HEIGHT = 38;
export const selectMenuPortalProps = {
  menuPortalTarget: typeof document !== "undefined" ? document.body : null,
  styles: {
    menuPortal: (base) => ({ ...base, zIndex: 1056 }),
    control: (base) => ({ ...base, minHeight: SELECT_HEIGHT, height: SELECT_HEIGHT }),
    valueContainer: (base) => ({ ...base, height: SELECT_HEIGHT, padding: "0 8px" }),
    input: (base) => ({ ...base, margin: 0, padding: 0 }),
    indicatorsContainer: (base) => ({ ...base, height: SELECT_HEIGHT }),
  },
};
